<template>
  <div>
    <p>{{lang.infotext_1}}: <b>{{ selectedLibrary }}</b><br>
      {{ lang.infotext_2 }}: <b>{{ libraryCategory }}</b></p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'InfoElementComponent',
  props:{
    lang: Object
  },
  components: {


  },
  data () {
      return {
        libraryCategory: "",
        ln: "",
        name: "InfoElementComponent"
      }
  },
  computed: {
    ...mapGetters({

      revisionHistory: 'revisionHistory',
      selectedRows: 'selectedRows',
      routingData: 'routingData'
    }),
    selectedLibrary(){
      let ln = this.ln;


      return ln;
    },
    lastRevisionHistory() {

      let tab = this.$store.getters.revisionHistory;
      let obj = tab[0];
      for (let i = 0, lei = tab.length; i < lei; i++) {

        if (tab[i].revision > obj.revision) {
          obj = tab[i];
        }
      }

      return obj;
    },
    reloadedAfterActionComplex() {
      return this.$store.getters.reloadedAfterActionComplex;
    },
    revisionId() {
      return this.$route.query.revisionId;
    }

  },
  created () {


    this.getCategory();
    this.getElementNumber();

  },
  watch: {
    selectedRows: function (newVal) {

      if (this.$store.getters.selectedRows.length > 0){

        this.getCategory();
        this.getElementNumber();
      }
    },
    lastRevisionHistory: function () {

      this.getCategory();
      this.getElementNumber();

    },
    reloadedAfterActionComplex: {
      handler: function (newValue) {

        for (let el in newValue) {

          if (newValue[el].name == this.name) {
            if (newValue[el].status == true) {

              this.getCategory();

              newValue[el].status = false;

              this.$store.dispatch("reloadAfterActionComplex", newValue[el]);
            }
          }
        }
      },
      deep: true

    },
    revisionId: function (newVal) {

      this.getCategory();
      this.getElementNumber();
    }
  },



  methods: {
    getElementNumber() {

      let vue = this;

      if (this.$route.query.revisionId == undefined){
        return
      }

      let obj = {
        revisionId: this.$route.query.revisionId
      }

      let action = "";
      let type = "";
      if (this.$store.getters.sectionPrefix == "pm"){
        action = "_getPart";
        type = "part number";

      }
      if (this.$store.getters.sectionPrefix == "lm"){
        action = "_getLibrary";
        type = "library number";

      }
      if (this.$store.getters.sectionPrefix == "projm"){
        action = "_getProject";
        type = "project number";

      }

      this.$store.dispatch(this.$store.getters.sectionPrefix + action, obj)
        .then(function (result) {
          console.log(result)

          if (result.status == "OK") {
            if (result.data != null) {
              for (let i = 0, lei = result.data.length; i < lei; i++) {
                if (result.data[i].type == type) {
                  vue.ln = result.data[i].value.display;
                }
              }
            }
          } else {

          }



        })



    },
    getCategory() {

      let vue = this;


      let obj = {
        revisionId: this.$route.query.revisionId
      }

      this.$store.dispatch(this.$store.getters.sectionPrefix + '_getCategoryByRevisionId', obj)
        .then((result) => {

          console.log(result)

          if (result.status == "OK") {
            if (result.data.length > 0) {
              let pos = result.data[0].categoryPath.indexOf("\\");

              let len = result.data[0].categoryPath.length;
              let str = result.data[0].categoryPath.substr(pos + 1, len);

              vue.libraryCategory = str;
            }


          }

        })
    },


  }
}
</script>


<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/shared/InfoElementComponent.vue